import { formatRewardAmount } from "@/lib/textUtils";

interface LeaderboardEntry {
  rank: number;
  name: string;
  amount: number;
}

interface LeaderboardListItemProps {
  entry: LeaderboardEntry;
  index: number;
}

export function LeaderboardListItem({ entry, index }: LeaderboardListItemProps) {
  return (
    <div 
      key={entry.rank || index} 
      className="grid grid-cols-4 gap-4 items-center py-3" 
      data-testid={`leaderboard-item-${index}`}
    >
      <div className="text-gray-900 font-bold space-grotesk">{entry.rank}</div>
      <div className="flex items-center gap-3">
        <span className="font-medium text-gray-900 space-grotesk">{entry.name}</span>
      </div>
      <div className="text-gray-900 font-bold space-grotesk">R{formatRewardAmount(entry.amount)}</div>
    </div>
  );
}
